<template>
    <div class="modal is-active" v-on:keyup.enter="saveChange"  v-on:keyup.esc="closeBtn" >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="dataToChild.kind=='d'" >Delete <strong> {{ dataToChild.name }} </strong>!!!!</p>
                <p class="modal-card-title " v-if="dataToChild.kind=='r'" >{{ dataToChild.name }}</p>
                <button class="delete" aria-label="close" @click="closeBtn"></button>
            </header>
            <section class="modal-card-body">
                <!-- Content ... -->
                <div class="notification is-danger" v-if="dataToChild.kind=='d'">
                   Data will be delete!!!, Are you sure to delete  that?
                </div>
                <div class="notification  is-info" v-if="dataToChild.kind=='r'">
                    Rename your folder name.
                </div>

                <b-message type="is-warning" has-icon v-if="dataToChild.dataUnderFolder.length>0 && dataToChild.kind=='d'">
                    <p>Existing data under folder name you want to delete!!!!!</p>
                    ฺ<v-jstree :data="dataToChild.dataUnderFolder "  allow-batch whole-row ></v-jstree>
                </b-message>

                <b-field label="Folder Name"  v-if="dataToChild.kind=='r'">
                    <b-input name="fname"  ref="fname" v-model="dataToChild.name"   ></b-input>
                </b-field>

            </section>
            <footer class="modal-card-foot">

                <button  v-if="dataToChild.kind=='r' " class="button  is-success"   @click="saveChange"    >
                  Save changes
                </button>

                <button  v-if="dataToChild.kind=='d' " class="button  is-danger"  @click="saveChange"    >
                  Delete
                </button>

                <button class="button" @click="closeBtn">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import VJstree from 'vue-jstree'
    export default {
        name: "DlgEditFolderName",
        components: {
            VJstree
        },
        mounted() {
            // check rename or delete
            if(this.dataToChild.kind === 'r'){
                this.$refs.fname.focus()
            }
        },
        props:{
            dataToChild : Object ,
        },
        methods:{
            closeBtn(){
                this.$emit('close')
            },
            saveChange(){
                this.$emit('closeWithChange',this.dataToChild)
                this.$emit('close')
            }
        },
    }
</script>

<style scoped>

</style>